<template><SimpleModuleDashboard :module-id="Modules.EMAIL_MARKETING" :profile-id="Profiles.PERSONAL" include-php-custom :actions="actions" /></template>
<script>
import Profiles from '@/config/profiles'
import Modules from '@/config/modules'
import SimpleModuleDashboard from '@/components/inc/dashboard/SimpleModuleDashboard'
export default { components: { SimpleModuleDashboard }, data: () => ({ Modules, Profiles, actions: [
  { id: 'configuration', reference: 'configuration', route: 'EmailMarketingStaffConfiguration', tone: 'primary' },
  { id: 'crudInformation', reference: 'crudInformation', route: 'EmailMarketingStaffCrudInformation', tone: 'primary' },
  { id: 'reports', reference: 'reports', route: 'EmailMarketingStaffReports', tone: 'primary' },
] }) }
</script>
